module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C127"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C134"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowle#page_ix"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduc#page_1"
    }
  }, [_vm._v("Introduction: Moral Imperfection: An Ethics for Democracy")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_1__After#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" After Virtue: The Strange Case of "), _c('em', [_vm._v("Belle Époque")]), _vm._v(" Socialist Antimaterialism")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_2__On_De#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" On Descent: Stories from the Gurus of Modern India")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Eleme#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Elementary Virtues: The Great War and the Crisis of European Man")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Incon#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Inconsequence: Some Little-Known Mutinies Around 1946")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Epilogue#page_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Paths of Ahimsaic Historiography")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Index#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5edd2513","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0